module.exports = __webpack_public_path__ + "static/img/log_bg.e59b1c60.png";